import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { useAppSelector } from "app/redux/hooks"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { adicionarItens } from "app/use-cases/orcamento/adicionarItens"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { ItensOrcamentoContainer } from "../itens-orcamento/ItensOrcamentoContainer"
import { DadosSugerirProdutoAgregado, ProdutosSugeridos, SugerirProdutoAgregado } from "./SugerirProdutoAgregado"
import { Parametro } from "app/types/Parametro";
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto"

export type SugerirProdutoAgregadoContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>
    foraOrcamento: boolean
}

export const SugerirProdutoAgregadoContainer = (props: SugerirProdutoAgregadoContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
    const [dados, setDados] = useState<DadosSugerirProdutoAgregado[]>()
    const [parametros, setParametros] = useState<Parametro[]>([])

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)
    
    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onObterProdutoAgregado = async () => {
        try {
            globalMU.blockUI()
            const resposta = await microuniversoApi.Produto.dadosProdutoAgregado({
                CodigoProdutoAnalisado: props.item.Codigo
            });
            // resposta == null PRIMEIRO: globalMU.tratarRetorno devolve null quando o servidor
            // responde com erro que não é DomainLayerException (a mensagem já foi exibida por ele).
            // Sem essa checagem, `"HasErrors" in null` estoura
            // "TypeError: Cannot use 'in' operator to search for 'HasErrors' in null".
            (resposta == null || "HasErrors" in resposta || resposta.length == 0) ? (setDados([]), globalMU.showWarnMessage('Nenhum registro encontrado.'), onVoltar()) : setDados(resposta)
        } catch (e) {
            onVoltar()
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        } 
    }

    const onVoltarGridItens = () => {
        
        renderizarComponentReact(
            < ItensOrcamentoContainer />,
            "conteudo-pagina",
            true
        )
    }

    const onAdicionarProdutosSugeridos = async (produtosSugeridos: ProdutosSugeridos[]) => {
        try {
            globalMU.blockUI()
            if (produtosSugeridos.length == 0) {
                globalMU.showErrorMessage('Por favor, selecione os produtos a serem adicionados.');
                return;
            }
            await adicionarItens(orcamento.IdentificadorOrcamento, produtosSugeridos)
            onVoltarGridItens()

        } catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    // const atualizarParametros = async () => {
    //     setParametros(
    //       await obterParametros({
    //         nomes: [
    //           "CHAVE_MOVIMENTACAO_ORCAMENTO"
    //         ]
    //       })
    //     )
    //   }
    
    // const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    useEffect(() => {
        passosInterno.current.set("Sugerir Produto Agregado",() => { renderizarComponentReact(<SugerirProdutoAgregadoContainer {...props} />, "conteudo-pagina", true) })
        onObterProdutoAgregado()
        //atualizarParametros()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="SugerirProdutoAgregadoContainer"
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
            />

            <br />

            <SugerirProdutoAgregado
                dadosSugerirProdutoAgregado={dados}
                codigo={ props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != ""  ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd() }
                descricao={props.item.Descricao}
                onOk={onAdicionarProdutosSugeridos}
                corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                foraOrcamento={props.foraOrcamento}
                
            />
        </>
    )
}